var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 22,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.64 19.9004H23.25V25.3804C23.25 25.7904 22.91 26.1304 22.5 26.1304C22.09 26.1304 21.75 25.7904 21.75 25.3804V19.9004H13.36C12.88 19.9004 12.5 20.2804 12.5 20.7604C12.5 26.6504 16.61 30.7604 22.5 30.7604C28.39 30.7604 32.5 26.6504 32.5 20.7604C32.5 20.2804 32.12 19.9004 31.64 19.9004Z",
    fill: "#3F7CDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2504 15.7997L24.8104 17.3597C25.1004 17.6497 25.5804 17.6497 25.8704 17.3597C26.1604 17.0697 26.1604 16.5897 25.8704 16.2997L23.0204 13.4597C22.7304 13.1697 22.2504 13.1697 21.9604 13.4597L19.1204 16.3097C18.9804 16.4597 18.9004 16.6497 18.9004 16.8397C18.9004 17.0297 18.9704 17.2197 19.1204 17.3697C19.4104 17.6597 19.8904 17.6597 20.1804 17.3697L21.7404 15.8097V19.8997H23.2404V15.7997H23.2504Z",
    fill: "#3F7CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchUpload);
export default __webpack_public_path__ + "static/media/batch-upload.b8548dd74d37d3255245c0e70f2cab78.svg";
export { ForwardRef as ReactComponent };